/* eslint-disable */
export default {
  activeCall: 'Actieve oproep',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
